import docReady from './Functions/docReady'

docReady(function () {
    if (window.location.hash !== '') {
        window.location.replace('/account?hash=' + window.location.hash.substring(1) + '&referrer=' + document.referrer);
    }
});
